<template>
  <div class="menu-self">
    <el-submenu :index="String(item.id)" popper-append-to-body>

      <template slot="title">
        <svg-icon icon-class="zip" />
        <span slot="title" class="title" v-if="!item.edit">{{item.name}}</span>
        <el-input class="input-name" slot="title" v-model="item.name" size="mini" placeholder="请输入" style="width:120px;height: 26px;line-height: 26px;" v-if="item.edit" @click.stop.native=""></el-input>
        <i class="el-icon-check" style="color:#06ff05; cursor: pointer; margin-left: 5px" v-if="item.edit" @click.stop="handleSave"></i>
        <i class="el-icon-close" style="color:#ff051a; cursor: pointer; margin-left: 5px" v-if="item.edit" @click.stop="handleCancel"></i>

        <el-popover placement="right" width="200" trigger="hover" class="popover-box" v-if="!isMenuCollapse && !item.edit">
          <div class="popover-butn-box">
            <span @click.stop="handleEdit" ><i class="el-icon-edit icon" style="color:#1890ff"></i>编辑组名</span>
            <span @click.stop="handleDelete" ><i class="el-icon-delete icon" style="color:#ff4949"></i>删除组名</span>
            <span><i class="el-icon-circle-plus-outline icon"></i>添加表（开发中）</span>
          </div>
          <i slot="reference" class="el-icon-more icon" style="color:#1890ff"></i>
        </el-popover>

      </template>

      <template v-if="item.data && item.data.length > 0">
        <el-menu-item v-for="son in item.data" :key="son.eventCode" :index="son.eventCode">
          <svg-icon icon-class="tree-table" />
          <span class="title" slot="title" :title="son.eventDesc">{{son.eventDesc}}</span>
          <svg-icon class="icon-share" slot="title" icon-class="folder-shared-line" @click.stop="handleAssign(son)" v-if="!isMenuCollapse" />
        </el-menu-item>
      </template>

      <template v-if="item.children && item.children.length > 0">
        <menu-list v-for="child in item.children" :key="child.id" :item="child" :allotGroup="allotGroup" :isMenuCollapse="isMenuCollapse" :renewList="renewList" />
      </template>
    
    </el-submenu>
  </div>
</template>

<script>
import { ajax_updateGroup, ajax_deleteGroup } from '@Sys~/api/sys'
export default {
  name: 'MenuList',
  props: {
    item: {
      type: Object,
      required: true
    },

    // 父级方法 配置分组
    allotGroup: {
      type: Function,
      default: null
    },

    // 父级方法 重新获取列表
    renewList: {
      type: Function,
      default: null
    },

    // 是否缩小
    isMenuCollapse: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    // 编辑组名
    handleEdit() {
      console.log('编辑')
      this.item.edit = true
      console.log('===', this.item)
    },

    // 保存组名
    handleSave() {
      if(!this.item.name){
          this.$message.error('组名不能为空');
          return
      }

      ajax_updateGroup(this.item.id, this.item.pid, this.item.name).then(response => {
          if(response.code == 1) {
              this.item.edit = false
              this.$message({
                  message: '修改组名成功',
                  type: 'success'
              });
              this.renewList() // 重新获取列表
          } 
      })
    },
    // 取消修改组名
    handleCancel() {
      // console.log('取消')
      this.item.name = this.item.originalName
      this.item.edit = false
    },

    // 分组配置
    handleAssign(item) {
      this.allotGroup(item)
    },

    // 删除组
    handleDelete() {
      this.$confirm('此操作将永久删除该组,是否继续？','提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {

        ajax_deleteGroup(this.item.id).then(response => {
          if(response.code == 1) {
              this.item.edit = false
              this.$message({
                  message: '成功',
                  type: 'success'
              });
              this.renewList() // 重新获取列表
          }
        })
      }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });    
      })
    }
  }
}
</script>

<style lang="scss">
  #app .hideSidebar .menu-self{
    overflow: initial;
    .el-submenu>.el-submenu__title .el-submenu__icon-arrow {
      display: block;
    }
    .el-submenu>.el-submenu__title .svg-icon {
      margin-left: 0px;
    }

    .menu-self .el-submenu>.el-submenu__title {
      padding-left:10px !important;
    }
  }

  #app .hidemenu .menu-self{
    overflow: hidden;

    .el-submenu>.el-submenu__title .el-submenu__icon-arrow {
      display: none !important;
    }

    .el-submenu>.el-submenu__title .svg-icon {
      margin-left: 10px;
    }

    .el-submenu>.el-submenu__title{
      padding: 0 !important;
    }

    .menu-box .el-submenu>.el-submenu__title {
      padding-left:0px !important;
    }

    .el-submenu__title > span{
      opacity: 0;
    }
  }

  .hideSidebar > .menu-self > .el-submenu > .el-submenu__title span {
    height: 0;
    width: 0;
    overflow: hidden;
    visibility: hidden;
    display: inline-block;
  }

  .menu-self {
    .el-menu{
      margin-top: 2px;
    }
    .el-submenu__icon-arrow{
      right: 10px;
    }

    .el-submenu__title{
      height: 30px;
      line-height: 30px;
      padding: 0 10px 0 0!important;
    }

    .el-menu-item{
      height: 30px;
      line-height: 30px;
      padding: 0 10px;
    }

    .el-menu--inline .el-menu-item{
      padding-left: 10px !important;
    }

    .menu-self .el-menu>.el-menu-item{
      padding-left: 20px !important;
    }

    .menu-self .el-submenu>.el-submenu__title {
      padding-left:10px !important;
    }
  }

</style>

<style lang="scss" scoped>
  .title{
      display: inline-block;
      width: auto;
      max-width: 170px;
      overflow: hidden; 
      text-overflow: ellipsis;
      white-space:nowrap
  }

  .icon{
    font-size: 16px;
  }

  .icon-share{
    float:right; 
    margin-right: 15px;
    margin-top:9px; 
    color:#13ce66;
    opacity: 0;
  }

  .el-menu-item:hover{
    .icon-share{
      opacity: 1;
    }
  }

  .el-menu--vertical{
    .el-menu-item{
      height: 30px;
      line-height: 30px;
      padding: 0 10px !important;
    }
    .el-submenu{
      padding-left: 10px !important;
    }
    .el-menu .svg-icon {
        margin-right: 6px;
    }
    .el-menu--popup{
      padding: 0 !important;
    }
    .el-menu-item:hover {
      background-color: #e8f4ff !important;
    }
  }

  .popover-box{
    float:right; 
    margin-right: 15px;
  }
  .popover-butn-box{
    display: flex;
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    span{
      display: block;
      width:100%;
      height: 30px;
      line-height: 30px;
      .icon{
        margin-right: 5px;
      }
    }
  }

</style>